import {
  LoginPageLeftSideLogo,
  LoginPageDaskIcon,
  LoginPageHealthIcon,
  LoginPageKaskoIcon,
  LoginPageTrafficIcon,
  LoginPageTravelIcon,
} from "../../libs/SVGIcons";

export const LoginLeftSidebar = () => {
  return (
    <div className="col-7 px-0 d-none d-none d-sm-block">
      <div className="container-fluid" style={{ position: "relative" }}>
        <div
          style={{
            position: "absolute",
            right: "-19%",
            bottom: "0px",
            zIndex: "0",
          }}
        >
          {/* TODO: Check or modify brand logo -i */}
        </div>
        <div className="row left-side-layer-1">
          <div className="col-8 offset-1">
            <h2 className="inter inter-bold login-page-section-title-1">
              {window.sys_app_translate(
                // TODO: Check or modify brand name
                // "Welcome to ITQAN Sigorta System"
                "Welcome to IQ Sigorta System",
                "en",
              )}
            </h2>
            <p className="inter inter-medium" style={{ marginTop: "30px" }}>
              {window.sys_app_translate(
                // "ITQAN Sigorta system provides a variety of insurances.",
                "IQ Sigorta system provides a variety of insurances.",
                "en",
              )}
            </p>
            <h2
              className="inter inter-bold login-page-section-title-2"
              style={{ marginTop: "30px" }}
            >
              {window.sys_app_translate("Our Expertise", "en")}
            </h2>
            <div className="container-fluid" style={{ marginTop: "58.7px" }}>
              <div className="row">
                <div className="col-3 text-center" style={{ width: "20%" }}>
                  <div
                    style={{
                      height: "47px",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                    }}
                  >
                    <LoginPageHealthIcon />
                  </div>
                  <div
                    className="inter inter-semi-bold"
                    style={{ fontSize: "14px", marginTop: "13px" }}
                  >
                    {window.sys_app_translate("Health Insurance", "en")}
                  </div>
                </div>
                <div className="col-3 text-center" style={{ width: "20%" }}>
                  <div
                    style={{
                      height: "47px",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                    }}
                  >
                    <LoginPageTravelIcon />
                  </div>
                  <div
                    className="inter inter-semi-bold"
                    style={{ fontSize: "14px", marginTop: "13px" }}
                  >
                    {window.sys_app_translate("Travel Insurance", "en")}
                  </div>
                </div>
                <div className="col-3 text-center " style={{ width: "20%" }}>
                  <div
                    style={{
                      height: "47px",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                    }}
                  >
                    <LoginPageDaskIcon />
                  </div>
                  <div
                    className="inter inter-semi-bold"
                    style={{ fontSize: "14px", marginTop: "13px" }}
                  >
                    {window.sys_app_translate("DASK Insurance", "en")}
                  </div>
                </div>
                <div className="col-3 text-center " style={{ width: "20%" }}>
                  <div
                    style={{
                      height: "47px",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                    }}
                  >
                    <LoginPageTrafficIcon />
                  </div>
                  <div
                    className="inter inter-semi-bold"
                    style={{ fontSize: "14px", marginTop: "13px" }}
                  >
                    {window.sys_app_translate("Traffic Insurance", "en")}
                  </div>
                </div>
                <div className="col-3 text-center " style={{ width: "20%" }}>
                  <div
                    style={{
                      height: "47px",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                    }}
                  >
                    <LoginPageKaskoIcon />
                  </div>
                  <div
                    className="inter inter-semi-bold"
                    style={{ fontSize: "14px", marginTop: "13px" }}
                  >
                    {window.sys_app_translate("Kasko Insurance", "en")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
